import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'SearchTypeTabs' })({
    root: {
        display: 'flex',
        gap: 4,
        padding: '4px',
        background: '#F5F5F5',
        borderRadius: 100,
        justifyContent: 'space-between',
        alignItems: 'center',
        boxSizing: 'border-box',
        width: '100%'
    },
    tab: {
        flex: 1,
        padding: '8px 12px',
        background: 'transparent',
        border: 'none',
        borderRadius: 20,
        fontSize: 14,
        lineHeight: '16px',
        fontWeight: 500,
        color: '#8E8E8E',
        cursor: 'pointer',
        transition: 'all 0.2s',
        whiteSpace: 'nowrap',
        textAlign: 'center',
        '&:hover': {
            opacity: 0.8
        },
        '&:active': {
            opacity: 0.6
        }
    },
    tabSelected: {
        background: '#FFFFFF',
        color: '#232323'
    }
});
